import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Banknote } from "lucide-react";
import { listClosings, money } from "../../../lib/closing";
import { listStores } from "../../../lib/emailTemplates";
import { ClosingDetail } from "./ClosingDetail";
import { ClosingsTable } from "./ClosingsTable";

const currentMonth = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/New_York" }).slice(0, 7);

const ClosingsTab = () => {
  const [items, setItems] = useState([]);
  const [stores, setStores] = useState([]);
  const [storeId, setStoreId] = useState("");
  const [month, setMonth] = useState(currentMonth);
  const [loading, setLoading] = useState(true);
  const [openId, setOpenId] = useState(null);

  const reload = async () => {
    setLoading(true);
    try { setItems(await listClosings({ ...(storeId ? { store_id: storeId } : {}), ...(month ? { month } : {}) })); }
    catch (e) { toast.error(e?.response?.data?.detail || "Load failed"); }
    finally { setLoading(false); }
  };
  useEffect(() => { listStores().then(setStores).catch(() => {}); }, []);
  useEffect(() => { reload(); }, [storeId, month]); // eslint-disable-line react-hooks/exhaustive-deps

  const open = items.find((c) => c.id === openId);
  const pending = items.filter((c) => !c.reconciliation).length;

  return (
    <div className="space-y-4" data-testid="admin-closings-tab">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h2 className="font-display text-2xl font-bold flex items-center gap-2"><Banknote size={20} /> Daily Closings</h2>
          <p className="text-xs text-[color:var(--ups-subtext)] mt-1">
            Register counts from the kiosk. Open a day to enter the UPS system split.
            {pending > 0 && <span className="ml-2 font-bold text-amber-700" data-testid="closings-pending-count">{pending} pending</span>}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <input type="month" value={month} onChange={(e) => { setMonth(e.target.value); setOpenId(null); }}
            className="input-swiss px-2 py-1.5 rounded-sm text-[13px]" data-testid="closings-month-filter" />
          <select value={storeId} onChange={(e) => { setStoreId(e.target.value); setOpenId(null); }} className="input-swiss px-2 py-1.5 rounded-sm text-[13px]" data-testid="closings-store-filter">
            <option value="">All stores</option>
            {stores.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>
        </div>
      </div>

      {open && <ClosingDetail key={open.id} closing={open} onClose={() => setOpenId(null)} onSaved={reload} />}

      {loading ? <div className="py-12 flex justify-center"><Loader2 className="animate-spin" /></div> : items.length === 0 ? (
        <div className="p-10 text-center rounded-sm text-[color:var(--ups-subtext)]" style={{ background: "#fff", border: "1px dashed var(--ups-border)" }} data-testid="closings-empty">
          No closings for this month.
        </div>
      ) : (
        <ClosingsTable items={items} openId={openId} onOpen={setOpenId} money={money} />
      )}
    </div>
  );
};

export default ClosingsTab;
